import * as React from "react";
import { Gapped, Hint, Link, Spinner } from "react-ui";

import { FORM_SAVE_CLICK, FORM_SAVE_ERROR } from "../../../metricsAction";
import { trackAction } from "../../../Internals/Metrics/MetricsProvider";
import { nullElement } from "../../../TypingUtils";
import { Icon } from "../../../Icons/Icon";
import { MenuAction } from "../../EmbeddedLog/MenuAction/MenuAction";

import * as cs from "./FormSaveStatus.styles";
import { FormSavingStatus } from "./Store/FormSaveStatusActions";

export interface FormSaveStatusProps {
    status: FormSavingStatus;
    onSaveForm: () => void;
}

export class FormSaveStatus extends React.Component<FormSaveStatusProps> {
    public render(): JSX.Element | null {
        switch (this.props.status) {
            case "success":
                return (
                    <div css={cs.container}>
                        <div css={cs.inner}>
                            <Icon name="CheckAIcon" />
                            <span css={cs.text}>{"Все изменения сохранены"}</span>
                        </div>
                    </div>
                );
            case "saving":
                return (
                    <div css={cs.container}>
                        <div css={cs.inner}>
                            <Spinner dimmed caption="Сохраняем..." type="mini" />
                        </div>
                    </div>
                );
            case "unsavedChanges":
                return (
                    <div css={cs.container}>
                        <div css={cs.inner}>
                            <MenuAction icon="CheckAIcon" text="Сохранить изменения" onClick={this.handleOnClickSave} />
                        </div>
                    </div>
                );
            case "error":
                return this.renderError();
            default:
                return nullElement;
        }
    }

    @trackAction(FORM_SAVE_CLICK)
    private readonly handleOnClickSave = () => {
        this.props.onSaveForm();
    };

    @trackAction(FORM_SAVE_ERROR)
    private renderError(): JSX.Element {
        return (
            <div css={cs.container}>
                <div css={cs.inner}>
                    <Gapped gap={10}>
                        <Link onClick={this.handleOnClickSave}>{"Повторить"}</Link>
                        <Hint maxWidth={200} text="Сохранить не удалось, попробуйте еще раз">
                            <span css={cs.error}>{"Не сохранено"}</span>
                        </Hint>
                    </Gapped>
                </div>
            </div>
        );
    }
}
